import HotelReviews from './HotelReviews';

import type { I18nService } from '@shared/types/i18n';
import type { EntityId } from '@shared/types/utils';

import HotelReviewsProvider from '@hotels-hotel-detail/data-access/HotelReviewsProvider';
import { withI18n } from '@shared/ui/contexts/i18n';

type Props = {
  i18n: I18nService;
  hotelId: EntityId;
};

const HotelReviewsContainer = ({ hotelId, i18n }: Props) => (
  <HotelReviewsProvider hotelId={hotelId} locale={i18n.culture.locale}>
    <HotelReviews />
  </HotelReviewsProvider>
);

export default withI18n(HotelReviewsContainer);
